<svelte:head>
  <link href="https://cdnjs.cloudflare.com/ajax/libs/cropperjs/2.0.0-alpha.2/cropper.css" rel="stylesheet">
  <script src="https://cdnjs.cloudflare.com/ajax/libs/cropperjs/2.0.0-alpha.2/cropper.min.js"></script>
</svelte:head>
<script>
  import { panelController } from "../../../stores/service.js";
  import MenuView from "../rest/menu.svelte"
  import { user } from "../../../stores/user";
  import { onMount } from "svelte";
  import {
    dataViewConfigS,
    beginview,
    uploadFile,
    controlBtn,
    inputControl,
  } from "../../../Controller/admin/config/ConfigService";

  let img, cropper;

  $: {
    console.log($dataViewConfigS);
    
    if ($dataViewConfigS.btn[0].status) {
      if (cropper) {
        cropper.destroy();
        cropper = null;
      }
      $dataViewConfigS.inputs[1].valid = false;
      $dataViewConfigS.inputs[1].fileLoad = false;
      $dataViewConfigS.inputs[4].fileLoad = false;
    }
  }

  onMount(async () => {
    if (!$dataViewConfigS.status) {
      document.title = "Ratingg | Ajustes";
      beginview(
        JSON.parse(JSON.stringify($panelController)),
        JSON.parse(JSON.stringify($dataViewConfigS))
      );
    }
  });

 async function menupdf(event) {

    if (!(228528634 > event.target.files[0].size)) {
      /* console.log("grande"); */
      $dataViewConfigS.inputs[4].messtxt = `Archivo muy grande, intente con otro menu`;
      $dataViewConfigS.inputs[4].styletxt = `valid-i`;
      $dataViewConfigS.inputs[4].valid = false;
      return;
    }
    
    $dataViewConfigS.inputs[4].value = event.target.files[0];
    URL.revokeObjectURL($dataViewConfigS.inputs[4].filePreview );
    $dataViewConfigS.inputs[4].filePreview = URL.createObjectURL($dataViewConfigS.inputs[4].value);
    
    $dataViewConfigS.inputs[4].messtxt = `Archivo seleccionado ${event.target.files[0].name}`;
    $dataViewConfigS.inputs[4].styletxt = `valid-c`;
    $dataViewConfigS.inputs[4].valid = true;


    $dataViewConfigS.inputs[4].fileLoad = true;
   
  }

  function handleImageSelect(event) {
    const file = event.target.files[0];
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      // Aquí se puede establecer el tamaño mínimo o máximo permitido
      if (img.width < 800 || img.height < 600) {
        /* console.log(
          "La imagen es demasiado pequeña. Debe ser al menos 800x600 píxeles."
        ); */
        /* valido la imagen */
        $dataViewConfigS.inputs[1].messtxt = `La imagen es demasiado pequeña. Debe ser al menos 800x600 píxeles.`;
        $dataViewConfigS.inputs[1].styletxt = `valid-i`;
        $dataViewConfigS.inputs[1].valid = false;

        return;
      } else {
        /* console.log("Imagen válida. Tamaño:", width, "x", height); */
      }

      URL.revokeObjectURL(objectUrl); // Liberar la memoria
    };

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        $dataViewConfigS.inputs[1].value = e.target.result;

        if (cropper) {
          cropper.destroy();
          cropper = null;
        }
      };
      reader.readAsDataURL(file);
    }
    $dataViewConfigS.inputs[1].fileLoad = true;

    /* valido la imagen */
    $dataViewConfigS.inputs[1].messtxt = `Recorta la imagen`;
    $dataViewConfigS.inputs[1].styletxt = `valid-c`;
    $dataViewConfigS.inputs[1].valid = true;
  }

  function initCropper() {
    if (img && $dataViewConfigS.inputs[1].value) {
      cropper = new Cropper(img, {
        aspectRatio: 4 / 4,
        viewMode: 1,
        autoCropArea: 1.0,
        zoomable: false,
        zoomOnWheel: false,
        zoomOnTouch: false,
        crop() {
          previewImage();
        },
      });
    }
  } 

  function previewImage() {
    const croppedCanvas = cropper.getCroppedCanvas();
    $dataViewConfigS.inputs[1].Cropper.croppedImageURL =
      croppedCanvas.toDataURL("image/jpeg");
  }
</script>



<div class="cfg">
  <div class="cfg-grid">
    <div class="field field-wide">
      <label for="cfg-name">Nombre del servicio</label>
      <input
        id="cfg-name"
        type="text"
        class="form-control"
        bind:value={$dataViewConfigS.inputs[0].value}
        on:input={() => inputControl("name")}
        disabled={$dataViewConfigS.inputs[0].active}
      />
      {#if $dataViewConfigS.inputs[0].messtxt}
        <p class="hint {$dataViewConfigS.inputs[0].styletxt}">
          {$dataViewConfigS.inputs[0].messtxt}
        </p>
      {/if}
    </div>

    <div class="field">
      <label for="cfg-mode">Modo</label>
      <select
        id="cfg-mode"
        class="form-control"
        bind:value={$dataViewConfigS.inputs[2].value}
        on:change={() => {
          inputControl("modo");
        }}
        disabled={$dataViewConfigS.inputs[2].active}
      >
        <option selected value={0}>Tipo de servicio</option>
        <option value={1}>Restaurante</option>
        <option value={2}>General</option>
      </select>
      {#if $dataViewConfigS.inputs[2].messtxt}
        <p class="hint {$dataViewConfigS.inputs[2].styletxt}">
          {$dataViewConfigS.inputs[2].messtxt}
        </p>
      {/if}
    </div>

    {#if $dataViewConfigS.inputs[2].value == 1}
      <div class="field">
        <label for="cfg-mesas">Mesas</label>
        <input
          id="cfg-mesas"
          type="number"
          inputmode="numeric"
          class="form-control"
          bind:value={$dataViewConfigS.inputs[3].value}
          on:input={() => {
            inputControl("mesas");
          }}
          disabled={$dataViewConfigS.inputs[3].active}
        />
        {#if $dataViewConfigS.inputs[3].messtxt}
          <p class="hint {$dataViewConfigS.inputs[3].styletxt}">
            {$dataViewConfigS.inputs[3].messtxt}
          </p>
        {/if}
      </div>

      <div class="field">
        <label for="cfg-img">Imagen del restaurante</label>
        <input
          id="cfg-img"
          class="form-control"
          accept="image/png, image/jpeg"
          type="file"
          on:change={handleImageSelect}
          disabled={$dataViewConfigS.inputs[1].active}
        />
        {#if $dataViewConfigS.inputs[1].messtxt}
          <p class="hint {$dataViewConfigS.inputs[1].styletxt}">
            {$dataViewConfigS.inputs[1].messtxt}
          </p>
        {/if}
      </div>

      <div class="field">
        <label for="Menu">Menú (PDF)</label>
        <input
          class="form-control"
          accept="application/pdf"
          id="Menu"
          type="file"
          on:change={menupdf}
          disabled={$dataViewConfigS.inputs[1].active}
        />
        {#if $dataViewConfigS.inputs[4].messtxt}
          <p class="hint {$dataViewConfigS.inputs[4].styletxt}">
            {$dataViewConfigS.inputs[4].messtxt}
          </p>
        {/if}
      </div>

      {#if $dataViewConfigS.inputs[1].fileLoad && !$dataViewConfigS.btn[0].status && $dataViewConfigS.inputs[1].value}
        <div class="crop-box field-wide">
          <img
            bind:this={img}
            src={$dataViewConfigS.inputs[1].value}
            alt="Imagen seleccionada"
            on:load={initCropper}
          />
        </div>
      {/if}
    {/if}
  </div>

  {#if $dataViewConfigS.saveError}
    <p class="hint valid-i save-error" role="alert">{$dataViewConfigS.saveError}</p>
  {/if}

  <div class="cfg-actions">
    {#each $dataViewConfigS.btn as item, index}
      {#if item.status}
        <button
          class="btn btn-sm {item.style}"
          on:click={() => {
            controlBtn(index, $panelController, $dataViewConfigS);
          }}
        >
          {item.text}
          <i class={item.ico}></i>
        </button>
      {/if}
    {/each}
  </div>
</div>

{#if !$dataViewConfigS.btn[0].status}
  <details class="preview">
    <summary>Vista previa</summary>
    <div class="card card-widget widget-user shadow-none mb-0">
      <div class="widget-user-header">
        <h5 class="widget-user-desc">
          {$dataViewConfigS.inputs[0].value}
        </h5>
      </div>
      <div class="widget-user-image">
        <img
          class="img-circle elevation-2"
          src={$dataViewConfigS.inputs[1].Cropper.croppedImageURL}
          alt=""
        />
      </div>
      <div class="card-footer">
        <h2 class="tx">Bienvenido</h2>
      </div>
      {#if $dataViewConfigS.inputs[4].fileLoad}
        <MenuView pdf={$dataViewConfigS.inputs[4].value} />
      {/if}
    </div>
  </details>
{/if}

<style>
  .cfg-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.6rem 0.75rem;
  }

  .field {
    min-width: 0;
  }

  .field-wide {
    grid-column: 1 / -1;
  }

  label {
    display: block;
    font-size: 0.78rem;
    font-weight: 600;
    color: #57543f;
    margin: 0 0 0.2rem;
  }

  .form-control {
    height: 2.25rem;
    padding: 0.25rem 0.6rem;
    font-size: 0.9rem;
  }

  input[type="file"].form-control {
    padding: 0.3rem 0.4rem;
    font-size: 0.8rem;
  }

  .hint {
    margin: 0.15rem 0 0;
    font-size: 0.75rem;
    line-height: 1.3;
  }

  .valid-c {
    color: #4c5a34;
  }

  .valid-i {
    color: #b14b2c;
  }

  .crop-box {
    max-width: 260px;
  }

  .crop-box img {
    display: block;
    max-width: 100%;
    padding: 0;
  }

  .cfg-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.9rem;
  }

  .preview {
    margin-top: 1rem;
  }

  .preview summary {
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 600;
    color: #57543f;
    padding: 0.35rem 0;
  }

  .preview :global(.widget-user-header) {
    height: auto;
    padding: 0.75rem;
    background-color: rgb(218, 92, 56);
    color: aliceblue;
    text-align: center;
  }

  .preview :global(.widget-user-image) {
    position: static;
    margin: -1.5rem auto 0;
    text-align: center;
  }

  .preview :global(.widget-user-image img) {
    width: 56px;
    height: 56px;
    padding: 0;
    object-fit: cover;
    display: inline-block;
  }

  .preview .tx {
    text-align: center;
    font-size: 1.1rem;
    margin: 0;
  }

  @media (max-width: 320px) {
    .cfg-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
